<div class="modal">
  <div class="container model-container add-number-modal {{context.customClass}}">
    <div class="modal-header">
      <h5 class="modal-heading" *ngIf="!successResult && !failureResult && !waitingConfirmCode">Add an Activated Number</h5>
      <h5 class="modal-heading" *ngIf="!successResult && !failureResult && !!waitingConfirmCode">Verify your Number</h5>
      <img src="assets/icon/popup-close-icon.svg" (click)="cancel()" class="close-icon"
      width="32" height="32" alt="Close Icon">
    </div>
    <div class="modal-body">
      <div class="modal-content" *ngIf="!successResult && !failureResult">
        <ng-container *ngIf="!waitingConfirmCode">
          <form [formGroup]="activatingPhoneForm" class="phone-number-section">
            <p class="subtitle">Enter your activated FreeUp Phone Number:</p>
            <div class="specific-width">
              <label class="outlined-label-input">
                <input placeholder=" " formControlName="phoneNumber" id="phoneNumber" data-cy="phoneNumber" type="tel"
                  required minlength="10" maxlength="10" restrictNumbers />
                <span>Enter Phone Number</span>
              </label>
              <label class="validation-message"
                *ngIf="activatingPhoneForm.controls.phoneNumber.hasError('required') && activatingPhoneForm.controls.phoneNumber.touched">
                Phone number is required
              </label>
              <label class="validation-message"
                *ngIf="!!activatingPhoneForm.controls.phoneNumber.value && activatingPhoneForm.controls.phoneNumber.hasError('minlength')">
                Phone number is invalid
              </label>
            </div>
          </form>
          <button class="button primary" (click)="sendCode()" type="submit" id="Confirm">Confirm
          </button>
        </ng-container>
        <ng-container *ngIf="!!waitingConfirmCode">
          <p class="confirm-code-title">We’ve sent a verification code to your Phone Number:</p>
          <p class="confirm-code-phone"><b>{{phoneNumber | phone}} </b></p>
          <form [formGroup]="verificationForm" class="verification-section">
            <div class="specific-width">
              <label class="outlined-label-input">
                <input placeholder=" " formControlName="verificationCode" id="verificationCode" type="tel" required
                  minlength="6" maxlength="6" restrictNumbers />
                <span>Enter Verification Code</span>
              </label>
              <label class="validation-message"
                *ngIf="verificationForm.controls.verificationCode.hasError('required') && verificationForm.controls.verificationCode.touched">
                Verification code is required
              </label>
              <label class="validation-message"
              *ngIf="!!verificationForm.controls.verificationCode.value && verificationForm.controls.verificationCode.hasError('minlength')">
              Verification code is invalid
            </label>
            </div>
          </form>
          <button class="button primary" (click)="verifyLoginCode()">Verify &
            Proceed
          </button>
        </ng-container>
      </div>
      <div class="modal-results" *ngIf="!!failureResult">
        <img src="/assets/icon/failure-res.svg" width="100"
          height="100" alt="result img">
        <h4 class="title">{{(customFailureResult? 'Invalid verification code': 'Something went wrong')}}</h4>
          <div class="inner-content">
          <p class="end-note">{{customFailureResult?'Recheck your entries and try again.':'We couldn’t process your request. Please try again later.'}}</p>
          </div>
          <button class="button primary" (click)="recheckIntries()" *ngIf="!!customFailureResult">Got it</button>
          <button class="button primary" (click)="cancel()" *ngIf="!customFailureResult">Got it</button>
      </div>
    </div>
  </div>
</div>
